import React from 'react'

const NotificationsContext = React.createContext();

export default NotificationsContext;
